import React from "react"
import SEO from "../components/common/SEO"
import ServicePageHero from "../components/services/ServicePageHero.jsx"

const rituals = [
  {
    id: 1,
    title: "Rituel Rêve d'Orient",
    price: "150 DT",
    description:
      "Une expérience orientale comprenant hammam traditionnel, savon noir, gommage et massage relaxant.",
  },

  {
    id: 2,
    title: "Rituel Indien",
    price: "240 DT",
    description:
      "Un voyage sensoriel inspiré des traditions indiennes associant soins du corps et massage ayurvédique.",
  },

  {
    id: 3,
    title: "Rituel Douceur",
    price: "280 DT",
    description:
      "Un rituel bien-être complet combinant hammam, enveloppement et massage pour une détente absolue.",
  },

  {
    id: 4,
    title: "Rituel Softness",
    price: "250 DT",
    description:
      "Une expérience relaxante conçue pour nourrir la peau, apaiser l'esprit et revitaliser le corps.",
  },

  {
    id: 5,
    title: "Rituel Jouvence",
    price: "300 DT",
    description:
      "Notre rituel signature anti-âge associant soins du visage, soins du corps et massage premium.",
  },
]

export default function RitualServices() {
  return (
    <>
      <SEO
        title="Rituels Spa | Centre SpaLand Saphir Palace & Spa"
        description="Découvrez nos rituels spa exclusifs combinant hammam, soins du corps, enveloppements et massages de luxe."
        keywords="rituel spa hammamet, hammam luxe, soins corps hammamet, spa tunisie"
        url="https://www.yourdomain.com/services/rituels"
      />

      <main>
        {/* Hero */}
        {/*
        <section
          style={{
            padding: "120px 20px",
            textAlign: "center",
            background: "#f9f6f1",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              marginBottom: "20px",
            }}
          >
            Rituels Spa
          </h1>

          <p
            style={{
              maxWidth: "750px",
              margin: "0 auto",
              color: "#666",
              lineHeight: "1.8",
            }}
          >
            Découvrez nos rituels exclusifs conçus pour offrir une expérience
            complète de relaxation, de bien-être et de revitalisation dans un
            cadre luxueux.
          </p>
        </section>
*/}
<ServicePageHero
  title="Rituels Spa"
  description="Des expériences exclusives combinant hammam, soins du corps et massages pour un voyage sensoriel inoubliable."
  image="/images/gallery-6.jpg"
/>
        {/* Ritual Cards */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "30px",
            }}
          >
            {rituals.map((ritual) => (
              <div
                key={ritual.id}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "30px",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                <h3
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  {ritual.title}
                </h3>

                <div
                  style={{
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#b8955d",
                    fontSize: "1.1rem",
                  }}
                >
                  {ritual.price}
                </div>

                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8",
                    marginBottom: "20px",
                  }}
                >
                  {ritual.description}
                </p>

                <a
                  href="https://wa.me/21697902051"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    background: "#b8955d",
                    color: "#fff",
                    padding: "12px 24px",
                    borderRadius: "50px",
                    textDecoration: "none",
                    fontWeight: "600",
                  }}
                >
                  Réserver via WhatsApp
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* Luxury CTA */}
        <section
          style={{
            padding: "100px 20px",
            textAlign: "center",
            background: "#111",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "20px",
            }}
          >
            Une Expérience Spa Inoubliable
          </h2>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto 30px",
              color: "#ddd",
            }}
          >
            Profitez d'un moment d'évasion unique grâce à nos rituels spa
            exclusifs conçus pour le corps et l'esprit.
          </p>

          <a
            href="https://wa.me/216XXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "#b8955d",
              color: "#fff",
              padding: "14px 30px",
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Réserver Maintenant
          </a>
        </section>
      </main>
    </>
  )
}